// Section for import npm components -----------------------------------------------------------------------------------
import React from 'react';

// Material UI ( mui )  components
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
// Section for import custom components --------------------------------------------------------------------------------
import MansionList from '@components/common/MansionList';

// Section for import custom types -------------------------------------------------------------------------------------
import MansionNearPropsData from '@/types/components/MansionDetail/MansionNearPropsData';

// Section for type definition -----------------------------------------------------------------------------------------

export default function MansionNearOnSale(props: MansionNearPropsData) {
  const { mansionName, mansionData } = props;

  if (mansionData.length === 0) return null;
  return (
    <Box
      id="section-near-area"
      className="md:max-w-7xl md:w-full mx-auto max-md:mx-0 mt-16 max-md:mt-12 mb-16 max-md:mb-10 px-24 max-md:px-5"
    >
      <Box>
        <Typography
          variant="h2"
          className="border-solid border-l-2 border-rf-black relative  mb-6 pl-4 text-lg font-bold before:absolute before:top-1 before:left-[-16px] max-md:before:left-0"
        >
          {mansionName}近くの売出し中物件
        </Typography>
      </Box>
      <MansionList results={mansionData} />
    </Box>
  );
}
